import {CanDeactivateComponent} from './can-deactivate-component';
import {AbstractControl, FormGroup} from '@angular/forms';
import {Component} from '@angular/core';

@Component({
  template: ''
})
export class CanDeactivateFormComponent<Model extends { [K in keyof Model]: AbstractControl; } = any> extends CanDeactivateComponent {
  isSubmitted = false;
  formGroup: FormGroup<Model>;

  onSubmit = (): void => {
    this.isSubmitted = true;
    this.dispatchSubmitAction();
  }

  dispatchSubmitAction = (): void => {
    throw new Error('Function dispatchSubmitAction is not implemented!');
  }

  canDeactivate(): boolean {
    if (this !== undefined && this.formGroup !== undefined) {
      return this.isSubmitted || !this.formGroup.dirty;
    } else {
      return false;
    }
  }
}
